import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/auth/redirect')({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/auth/redirect"!</div>;
}
